import { ILine } from './types'
import { IControlledShiftFunction4Point } from './types'

import { Line } from 'react-chartjs-2';
import 'chartjs-plugin-dragdata'
import { useStyletron } from 'baseui';
import { addAlpha } from '../../../utils/colorUtils'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { Element } from 'chart.js';


interface IDictionary {
    [index: string]: any;
}

const LineDisplay: React.FC<IControlledShiftFunction4Point> = ({ ...props }) => {
    const [, theme] = useStyletron();

    const [outTMax, setOutTMax, setOutTMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "outTMax", props.outTMax);
    const onOutTMaxChanged = (e: any) => setOutTMax(parseFloat(e.target.value));

    const [outT2, setOutT2, setOutT2Result] = useSetObjectValue(props.id, props.resourceGroupId, "outT2", props.outT2);
    const onOutT2Changed = (e: any) => setOutTMax(parseFloat(e.target.value));

    const [outT1, setOutT1, setOutT1Result] = useSetObjectValue(props.id, props.resourceGroupId, "outT1", props.outT1);
    const onOutT1Changed = (e: any) => setOutTMax(parseFloat(e.target.value));

    const [outTBase, setOutTBase, setOutTBaseResult] = useSetObjectValue(props.id, props.resourceGroupId, "outTBase", props.outTBase);
    const onOutTBaseChanged = (e: any) => setOutTBase(parseFloat(e.target.value));

    const [flowMax, setFlowMax, setFlowMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "flowMax", props.flowMax);
    const onFlowMaxChanged = (e: any) => setFlowMax(parseFloat(e.target.value));

    const [flow2, setFlow2, setFlow2Result] = useSetObjectValue(props.id, props.resourceGroupId, "flow2", props.flow2);
    const onFlow2Changed = (e: any) => setFlow2(parseFloat(e.target.value));

    const [flow1, setFlow1, setFlow1Result] = useSetObjectValue(props.id, props.resourceGroupId, "flow1", props.flow1);
    const onFlow1Changed = (e: any) => setFlow1(parseFloat(e.target.value));

    const [flowBase, setFlowBase, setFlowBaseResult] = useSetObjectValue(props.id, props.resourceGroupId, "flowBase", props.flowBase);
    const onFlowBaseChanged = (e: any) => setFlowBase(parseFloat(e.target.value));


    const data = {
        lines: [
            {
                name: 'Heating',
                points: [
                    { x: outTMax, y: flowMax },
                    { x: outT2, y: flow2 },
                    { x: outT1, y: flow1 },
                    { x: outTBase, y: flowBase },
                ],
                key: 'heating',
            },
            {
                name: 'ActSetpoint',
                points: [
                    { x: props.outsideTemperature, y: props.actSetpoint },
                ],

                key: 'default',
            },
            {
                name: 'OutsideTemperatur',
                points: [
                    { x: props.outsideTemperature, y: 0 },
                    { x: props.outsideTemperature, y: 80 },
                ],

                key: 'default',
            }
        ]
    };
    const mylines = data.lines;
    const colors = {
        'heatrecovery': { color: theme.colors.positive },
        'heating': { color: theme.colors.warning },
        'cooling': { color: theme.colors.accent },
        'default': { color: theme.colors.accent },
    } as IDictionary

    const datas = {
        type: 'scatter',
        datasets: mylines.map((line: any, index: number) => {
            const col = colors[line.key || 'default'];
            return {
                id: index,
                label: line.name,
                data: line.points,
                //fill: true,

                pointRadius: index<1? 10:index<2? 5:0,
                pointHoverRadius: index<1? 20:index<2? 5:0,
                borderColor: col.color,
                backgroundColor: addAlpha(col.color, 0.5),
            }
        })
    }

    const options: any = {
        responsive: true,
        legend: {
            display: true
        },
        scales: {
            y: {
                type: 'linear',
                ticks: {
                    display: true,
                },
                min: 0,
                max: 80,
                grid: {
                    display: true,
                    drawBorder: false,
                    drawOnChartArea: true,
                    drawTicks: false,
                },
                title: {
                    display: true,
                    text: 'Flow Temperature [°C]'
                }

            },
            x: {
                type: 'linear',
                ticks: {
                    display: true,
                },
                title: {
                    display: true,
                    text: 'Outside Temperature [°C]'
                },
                min: outTMax,
                max: outTBase,
                grid: {
                    display: true,
                    drawBorder: false,
                    drawOnChartArea: true,
                    drawTicks: false,
                },
            }
        },
        plugins: {
            // https://github.com/chrispahm/chartjs-plugin-dragdata
            dragData: {
                round: 1, // rounds the values to n decimal places 
                // in this case 1, e.g 0.1234 => 0.1)
                showTooltip: true, // show the tooltip while dragging [default = true]
                dragX: false, // also enable dragging along the x-axis.
                dragY: true,
                // this solely works for continous, numerical x-axis scales (no categories or dates)!
                onDragStart: function (e: any, element: any) {
                    //console.log('onDragStart')
                    // e = event, element = datapoint that was dragged
                    // you may use this callback to prohibit dragging certain datapoints
                    // by returning false in this callback
                    if (element > 0) {
                      // this would prohibit dragging the first datapoint in the first
                      // dataset entirely 
                      return false
                    }  
                    
                },
                onDrag: function (e: any, datasetIndex: any, index: any, value: any) {
                    /*     
                    // you may control the range in which datapoints are allowed to be
                    // dragged by returning `false` in this callback
                    if (value < 0) return false // this only allows positive values
                    if (datasetIndex === 0 && index === 0 && value > 20) return false 
                    */
                },
                onDragEnd: function (e: any, datasetIndex: any, index: any, value: any) {
                    if (datasetIndex === 0) {
                        if (index === 0) {
                            setOutTMax(value.x)
                            setFlowMax(value.y)
                        }
                        if (index === 1) {
                            setOutT2(value.x)
                            setFlow2(value.y)
                        }
                        if (index === 2) {
                            setOutT1(value.x)
                            setFlow1(value.y)
                        }
                        if (index === 3) {
                            setOutTBase(value.x)
                            setFlowBase(value.y)
                        }
                    }
                    // you may use this callback to store the final datapoint value
                    // (after dragging) in a database, or update other UI elements that
                    // dependent on it
                },
            }
        }
    };

    return (
        <Line datasetIdKey='id' data={datas} options={options}></Line>
    );



};

export default LineDisplay;



